import _ from 'lodash';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { formActions } from '../../../Actions';
import { GeneralDetails } from '../../../Components/Forms/RiderForm';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	StyledTab,
	StyledTabs,
	TabPanel,
} from '../../../Components/StyledTabs';
import { history, isEmpty } from '../../../Helpers';
import RiderConfig from './rider.config';

const TABS = ['GENERAL DETAILS'];
const RiderViewPage = (props) => {
	const { fetchRider, data, deleteRider, breadcrumbs } = props;

	const [state, setState] = useState({
		activeTab: 0,
		fields: _.cloneDeep(RiderConfig.initialState.fields),
	});

	const RiderId = useRouteMatch().params.id;

	useEffect(() => {
		fetchRider({
			entity: 'RIDERS',
			req: {
				params: {
					id: RiderId,
				},
			},
			method: 'VIEW',
		});
	}, []);

	useEffect(() => {
		if (!isEmpty(data)) {
			RiderConfig.serializer(state, data).then((newState) => {
				setState(newState);
			});
		}
	}, [data]);

	const { activeTab, fields } = state;
	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const renderInfo = (idx) => {
		switch (idx) {
			case 0:
				return <GeneralDetails isDisabled fields={fields} />;
			default:
				return <></>;
		}
	};

	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};
	const handleDelete = () => {
		const splitURL = url.split('/view');
		deleteRider({
			entity: 'RIDERS',
			req: {
				params: {
					id: RiderId,
				},
			},
			method: 'DELETE',
		});
		history.push(splitURL[0]);
	};
	return (
		<div className='root'>
			<ViewPageHeader
				heading='View Rider'
				handleEdit={redirectToEdit}
				handleDelete={handleDelete}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${fields.name}`,
					},
				]}
				showBreadcrumbs
			/>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						{renderInfo(idx)}
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.RIDERS.data.VIEW;
	return {
		data,
	};
};

const mapDispatchToProps = {
	fetchRider: formActions.gateway,
	deleteRider: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderViewPage);
